// extracted by mini-css-extract-plugin
module.exports = {"modal-wrapper":"style_modal-wrapper__Gwtgp","captcha-modal":"style_captcha-modal__wKjK8","buttons":"style_buttons__2SWSU","input":"style_input__2Qcs_"};